import React from "react";
import { Row, Col, Button, Input, DatePicker } from "antd";
import "./MenuVertical.css";
const { TextArea } = Input;
const RejectConfirm = (props) => {
  return (
    <div
      style={{
        width: "300px",
      }}
    >
      <div className="Container">
        <div style={{ marginTop: 20 }}>
            <Row gutter={(16, 16)}>
                <Col span={24}>
                    <div className="Label" style={{ marginBottom: 5 }}>
                        Тайлбар
                    </div>
                    <TextArea
                        rows={3}
                        defaultValue={null}
                        onChange={props.onChangeDescription}
                    />
                </Col>
            </Row>
        </div>
        </div>
      <Row justify="end" align="middle">
        <Col>
          <Button
            type="primary"
            style={{
              backgroundColor: "#0358A7",
              borderRadius: 4,
              marginTop: 20,
            }}
            onClick={props.onClickYes}
          >
            Цуцлах
          </Button>
        </Col>
        <Col>
          <Button
            type="default"
            style={{
              fontWeight: 600,
              fontSize: 14,
              color: "#212121",
              borderRadius: 2,
              marginTop: 20,
              marginLeft: 10,
            }}
            onClick={props.onClickNo}
          >
            Болих
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default RejectConfirm;
